import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepThreeExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepThreeExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.discoverStepThreeExtraCollections.data
      .discoverStepThreeExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.discoverStepThreeExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
